module.exports = __webpack_public_path__ + "img/1725849152129-screenshot-1725849138207.png.ade6c0c3.webp";